import type { AccountEntitlementsResponse } from '../../types/api';
import { apiFetch } from './client';

export function fetchAccountEntitlements(): Promise<AccountEntitlementsResponse> {
  return apiFetch<AccountEntitlementsResponse>('/api/account/entitlements');
}
